import React from "react";
import CloseIcon from "../../icons/close-icon";

import lbl from "../../data/Labels.json";

const MainFilter = ({ showFilter, inputs, handleSubmit }) => {
  const renderInput = (p = new Object()) => {
    return (
      <div className="filter-input" key={p.name}>
        <label htmlFor={p.name}>{p.label}</label>
        {handleInputType(p)}
      </div>
    );
  };

  const handleInputType = (p = new Object()) => {
    if (p.type === "select") {
      return (
        <select name={p.name} id={p.name}>
          <option value="" key={-1} hidden></option>
          {p?.data.length > 0 ? (
            p.data.map((opt, i) => (
              <option key={i} value={opt.id}>
                {opt.name}
              </option>
            ))
          ) : (
            <option value="">اطاعات موجود نیست</option>
          )}
        </select>
      );
    }
    return (
      <input
        placeholder={p.placeHolder}
        maxLength={p.maxLength}
        type={p.type}
        name={p.name}
        id={p.name}
      />
    );
  };

  return (
    <React.Fragment>
      <div className="filter-card-container">
        <form className="filter-card" onSubmit={(e) => handleSubmit(e)}>
          <div className="filter-title">
            <p>{lbl.Filter}</p>
            <i onClick={() => showFilter(false)}>
              <CloseIcon />
            </i>
          </div>
          <div className="filter-input-wrapper">
            {inputs.map((input) => renderInput(input))}
          </div>
          <div className="filter-button">
            <button>{lbl.Search}</button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default MainFilter;
